/*
 * ANANDA Footer Droplets — condensation droplets, FOOTER ONLY.
 *
 * Injected via JS (loaded globally by ananda-fx.liquid) rather than edited
 * into the 26 KB sections/footer.liquid, to avoid reproducing that large
 * critical file for a purely decorative effect. Scoped strictly to
 * <footer class="footer"> + the .ananda-footer-drops layer, so it appears
 * NOWHERE else. Fail-safe: if this script doesn't run, nothing breaks.
 *
 * Same look as the age-gate / reusable droplets (white drops sliding down
 * with a faint trailing streak), but travel is CONTAINER-relative (top
 * -15% -> 115% of the footer height) instead of viewport-based, so it
 * reads correctly inside a short footer. White-on-dark works because the
 * footer uses scheme-5 (dark teal #0c4a4b).
 */
(function () {
  function init() {
    var footer = document.querySelector('footer.footer');
    if (!footer || footer.dataset.anandaFooterDrops === '1') return;
    footer.dataset.anandaFooterDrops = '1';

    if (!document.getElementById('ananda-footer-drops-style')) {
      var st = document.createElement('style');
      st.id = 'ananda-footer-drops-style';
      st.textContent = [
        'footer.footer.ananda-has-drops{position:relative;}',
        'footer.footer.ananda-has-drops>*:not(.ananda-footer-drops){position:relative;z-index:1;}',
        '.ananda-footer-drops{position:absolute;inset:0;overflow:hidden;pointer-events:none;z-index:0;}',
        '.ananda-footer-drops span{position:absolute;top:-15%;left:var(--d-left,50%);width:var(--d-size,14px);height:calc(var(--d-size,14px)*1.25);border-radius:48% 52% 50% 50% / 56% 56% 44% 44%;background:radial-gradient(circle at 35% 28%,rgba(255,255,255,0.7),rgba(255,255,255,0.16) 55%,rgba(255,255,255,0.04) 78%);border:1px solid rgba(255,255,255,0.25);animation:anandaFooterDrop var(--d-dur,12s) ease-in var(--d-delay,0s) infinite;}',
        '.ananda-footer-drops span::after{content:"";position:absolute;left:50%;bottom:55%;transform:translateX(-50%);width:1.5px;height:500%;border-radius:2px;background:linear-gradient(to top,rgba(255,255,255,0.22),rgba(255,255,255,0));}',
        '@keyframes anandaFooterDrop{0%{top:-15%;opacity:0;transform:translateX(0) scale(0.7);}12%{opacity:0.7;}88%{opacity:0.7;}100%{top:115%;opacity:0;transform:translateX(var(--d-drift,6px)) scale(1);}}',
        '@media (prefers-reduced-motion:reduce){.ananda-footer-drops{display:none;}}'
      ].join('');
      document.head.appendChild(st);
    }

    footer.classList.add('ananda-has-drops');
    var wrap = document.createElement('div');
    wrap.className = 'ananda-footer-drops';
    wrap.setAttribute('aria-hidden', 'true');
    for (var i = 1; i <= 16; i++) {
      var s = document.createElement('span');
      var dleft = (i * 61) % 100;
      var dsize = (i % 4) * 6 + 8;
      var ddur = (i % 7) * 2 + 7;
      var ddelay = ((i % 9) * 11 - 40) / 10;
      var ddrift = (i % 3) * 6 - 6;
      s.style.cssText = '--d-left:' + dleft + '%;--d-size:' + dsize + 'px;--d-dur:' + ddur + 's;--d-delay:' + ddelay + 's;--d-drift:' + ddrift + 'px;';
      wrap.appendChild(s);
    }
    footer.insertBefore(wrap, footer.firstChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
